import axios from "axios";
import {
    authHeader,
    handleResult,
    handleException,
} from '../helpers';

export const congestionsService = {
    getAll,
    getById,
    saveCongestion,
    attest,
    deleteCongestion
};

function getAll(userId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("congestiontax/user/" + userId, requestOptions)
        .then(handleResult);
}

function getById(congestionId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("congestiontax/" + congestionId, requestOptions)
        .then(handleResult).catch(handleException);
}

function saveCongestion(congestion) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.patch(`congestiontax/${congestion.id}`, congestion , requestOptions)
        .then(handleResult).catch(handleException);
}

function attest(congestionId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.patch(`congestiontax/${congestionId}/attest`, null , requestOptions)
        .then(handleResult).catch(handleException);
}

function deleteCongestion(congestion) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.delete(`congestiontax/${congestion.id}`, requestOptions)
        .then(handleResult).catch(handleException);
}
